/* eslint-disable eqeqeq */
/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import PagesContainer from "src/components/shared/molecules/PagesContainer";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import { useLazyQuery, useSubscription } from "@apollo/client";
import PendingSkeleton from "src/components/pages/dashboard/skeleton/dashboard/PendingTable";
import { useSnackbar as Snackbar } from "notistack";
import GETDASHBOARDUSERDATA from "src/graphql/query/dashboard/FigureCards/getActiveUsersData";
import GET_DASHBOARD_AGENT_SUBSCRIPTION from "src/graphql/subscriptions/dashboard/getDashboardAgents";
import Dropdown from "src/components/shared/molecules/dropdown";
import useStyles from "./Styles";

const DashboardUsers = () => {
  const { classes } = useStyles();
  const { enqueueSnackbar } = Snackbar();
  const { agentId, panelType, mainSuperAdminId } = useActiveUserDetail();
  const [pendingPages, setPendingPages] = useState<any[]>([]);

  const listData = pendingPages;
  //
  const { data: getDashboardAgentsSubscriptionResult } = useSubscription(
    GET_DASHBOARD_AGENT_SUBSCRIPTION,
  );
  useEffect(() => {
    if (
      getDashboardAgentsSubscriptionResult &&
      getDashboardAgentsSubscriptionResult.dashboardusers
    ) {
      const filteredData =
        getDashboardAgentsSubscriptionResult.dashboardusers.filter(
          (item: {
            mainSuperAdminId: string;
            managerId: string;
            agentId: string;
          }) =>
            Number(item.mainSuperAdminId) == Number(mainSuperAdminId) ||
            item.managerId == agentId ||
            item.agentId == agentId,
        );

      setPendingPages((prev) =>
        prev.map((item) => {
          const filteredItem = filteredData.find(
            (filteredDataItem: { agentId: string | number }) =>
              filteredDataItem.agentId == item.agentId,
          );
          if (filteredItem) return filteredItem;
          return item;
        }),
      );
    }
  }, [getDashboardAgentsSubscriptionResult]);
  const [
    getDashboardUsers,
    { data: getDashboardUsersResult, loading: getActiveUserDataLoading },
  ] = useLazyQuery(GETDASHBOARDUSERDATA, {
    fetchPolicy: "network-only",
  });

  const dashboardUsersFunction = (cursor: number, limit: number) => {
    if (panelType && mainSuperAdminId && agentId && limit)
      getDashboardUsers({
        variables: {
          agentId,
          paneltype: panelType,
          mainSuperAdminId,
          limit,
          cursor,
          query: "",
        },
      });
  };
  useEffect(() => {
    if (panelType !== "AGENT") dashboardUsersFunction(0, 100);
  }, [panelType, mainSuperAdminId, agentId]);

  useEffect(() => {
    if (getDashboardUsersResult && getDashboardUsersResult.getDashboardUsers) {
      if (getDashboardUsersResult.getDashboardUsers.success) {
        const pendingData = getDashboardUsersResult.getDashboardUsers.data;
        setPendingPages(pendingData);
      } else {
        enqueueSnackbar(getDashboardUsersResult.getDashboardUsers.error, {
          variant: "error",
        });
      }
    }
  }, [getDashboardUsersResult]);

  // select
  const [usersSelectValue, setUsersSelectValue] = useState("all");

  const handleChangeSelect = (event: SelectChangeEvent) => {
    const selectedValue = event.target.value as string;
    setUsersSelectValue(selectedValue);
  };

  const userOptions = [
    { label: "All", value: "all" },
    { label: "Active", value: "active" },
    { label: "Away", value: "away" },
  ];

  return getActiveUserDataLoading ? (
    <Box className={classes.skeletonBox}>
      <PendingSkeleton />
    </Box>
  ) : (
    <Box id="tour-dashboard-users" className={classes.rootItem}>
      <Box className={classes.flex}>
        <Typography className={classes.headerText}>Users</Typography>
        {/* </StyledBadge> */}
        <Box>
          <Dropdown
            usersSelectValue={usersSelectValue}
            handleChangeSelect={handleChangeSelect}
            options={userOptions}
          />
        </Box>
      </Box>

      <Box className={classes.pagesContainer}>
        <PagesContainer
          title="Users"
          dataList={listData
            .filter((item) => {
              if (usersSelectValue === "active") {
                return item.isOnline;
              }
              if (usersSelectValue === "all") {
                return true;
              }
              return !item.isOnline;
            })
            .map((item) => ({
              name: item?.username,
              ...item,
            }))}
          chatTitle="Users"
        />
      </Box>
    </Box>
  );
};

export default DashboardUsers;
